import type { ModelProviderIdType } from "@app/types/assistant/models/types";

export type ProvidersSelection = Record<ModelProviderIdType, boolean>;

export const ALL_PROVIDERS_SELECTED: ProvidersSelection = {
  openai: true,
  anthropic: true,
  mistral: true,
  google_ai_studio: true,
  deepseek: true,
  fireworks: true,
  xai: true,
  noop: true,
  auto: true,
  auto_fast: true,
  auto_complex: true,
};

export const NO_PROVIDERS_SELECTED: ProvidersSelection = {
  openai: false,
  anthropic: false,
  mistral: false,
  google_ai_studio: false,
  deepseek: false,
  fireworks: false,
  xai: false,
  noop: false,
  auto: true,
  auto_fast: true,
  auto_complex: true,
};

export const PRETTIFIED_PROVIDER_NAMES: Record<ModelProviderIdType, string> = {
  openai: "OpenAI",
  anthropic: "Anthropic",
  mistral: "Mistral AI",
  google_ai_studio: "Google",
  deepseek: "Deepseek",
  fireworks: "Fireworks",
  xai: "xAI",
  noop: "noop",
  auto: "Auto",
  auto_fast: "Fast",
  auto_complex: "Complex",
};
